import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs';

import { AuthenticationService } from 'app/services/authentication.service';

export const superAdminOnlyGuard: CanActivateFn = () => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  return authService.getMe().pipe(
    take(1),
    map((user) => {
      if (user.roles.some((r) => r === 'superAdmin')) {
        return true;
      }
      return router.createUrlTree(['/']);
    }),
  );
};

export const redirectSuperAdminGuard: CanActivateFn = () => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  if (sessionStorage.getItem('impersonatedTenant')) {
    return true;
  }

  return authService.getMe().pipe(
    take(1),
    map((user) => {
      if (user.roles.some((r) => r === 'superAdmin')) {
        return router.createUrlTree(['/tenants']);
      }
      return true;
    }),
  );
};
